import { render, staticRenderFns } from "./InformList.vue?vue&type=template&id=38d5e619&scoped=true&"
import script from "./InformList.vue?vue&type=script&lang=js&"
export * from "./InformList.vue?vue&type=script&lang=js&"
import style0 from "./InformList.vue?vue&type=style&index=0&id=38d5e619&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d5e619",
  null
  
)

export default component.exports